var collapsible_list_component_default = {
  "ltr": "CPLL1",
  "rtl": "GJPcy",
  "iconContainer": "MnAqW",
  "icon": "pqVbA",
  "isExpanded": "_4iyrU",
  "listDimensions": "bjfu3"
};
export {
  collapsible_list_component_default as default
};
//# sourceMappingURL=collapsible-list-component-scss.js.map
